import React, { useState } from 'react';
import '../cierreTurno/CierreTurno.css';

/* Formulario 1: Consultar factura (solo búsqueda) */
const FormularioConsultar = ({ filtros, onChange, onSubmit, onClear }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await onSubmit(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-section">
      <h3 className="form-title">Consultar factura</h3>
      <form onSubmit={handleSubmit} className="form-container">
        <div className="form-layout">
          <div className="filtro-campos">
            <div className="filtro-grupo">
              <label>Código Terminal:</label>
              <input
                type="text"
                name="codTerminal"
                value={filtros.codTerminal}
                onChange={onChange}
                className="filtro-input"
                placeholder="Ingrese el código terminal"
              />
            </div>
            <div className="filtro-grupo">
              <label>Código Parqueadero:</label>
              <input
                type="text"
                name="codPark"
                value={filtros.codPark}
                onChange={onChange}
                className="filtro-input"
                placeholder="Ingrese el código parqueadero"
              />
            </div>
            <div className="filtro-grupo">
              <label>Número de Factura:</label>
              <input
                type="text"
                name="numFactura"
                value={filtros.numFactura}
                onChange={onChange}
                className="filtro-input"
                placeholder="Ingrese el número de factura"
              />
            </div>
          </div>
        </div>
        <div className="buttons-container">
          <button type="submit" className="btn-primary" disabled={isLoading}>
            {isLoading ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-search"></i>}
            {isLoading ? 'Buscando...' : 'Buscar'}
          </button>
          <button type="button" className="btn-secondary" onClick={onClear} disabled={isLoading}>
            <i className="fas fa-eraser"></i> Limpiar
          </button>
        </div>
      </form>
    </div>
  );
};

/* Formulario 2: Liberar factura (procedimiento almacenado) */
const FormularioLiberar = ({ liberarFiltros, onChange, onLiberarFactura, onClearLiberar, liberando }) => (
  <div className="form-section">
    <h3 className="form-title">Liberar factura</h3>
    <div className="form-container">
      <div className="form-layout">
        <div className="filtro-campos">
          <div className="filtro-grupo">
            <label>Código Parqueadero:</label>
            <input
              type="text"
              name="cod_park"
              value={liberarFiltros.cod_park}
              onChange={onChange}
              className="filtro-input"
              placeholder="Código parqueadero"
            />
          </div>
          <div className="filtro-grupo">
            <label>Terminal:</label>
            <input
              type="text"
              name="terminal"
              value={liberarFiltros.terminal}
              onChange={onChange}
              className="filtro-input"
              placeholder="Terminal"
            />
          </div>
          <div className="filtro-grupo">
            <label>Número de Factura:</label>
            <input
              type="text"
              name="numero_factura"
              value={liberarFiltros.numero_factura}
              onChange={onChange}
              className="filtro-input"
              placeholder="Número de factura"
            />
          </div>
          <div className="filtro-grupo">
            <label>Valor Descuento:</label>
            <input
              type="text"
              inputMode="decimal"
              name="valorDescuento"
              value={liberarFiltros.valorDescuento ?? ""}
              onChange={onChange}
              className="filtro-input"
              placeholder="Valor descuento"
            />
          </div>
        </div>
      </div>
      <div className="buttons-container">
        <button
          type="button"
          className="btn-primary"
          onClick={onLiberarFactura}
          disabled={liberando}
          style={{ backgroundColor: liberando ? '#6c757d' : '#28a745' }}
        >
          {liberando ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-unlock"></i>}
          {liberando ? 'Liberando...' : 'Liberar factura'}
        </button>
        <button type="button" className="btn-secondary" onClick={onClearLiberar} disabled={liberando}>
          <i className="fas fa-eraser"></i> Limpiar
        </button>
      </div>
    </div>
  </div>
);

const CierreDiaListForm = ({
  filtros,
  onChange,
  onSubmit,
  onClear,
  liberarFiltros,
  onLiberarFiltroChange,
  onLiberarFactura,
  onClearLiberar,
  liberando,
}) => (
  <div className="forms-container">
    <FormularioConsultar
      filtros={filtros}
      onChange={onChange}
      onSubmit={onSubmit}
      onClear={onClear}
    />
    <div className="form-separator"></div>
    <FormularioLiberar
      liberarFiltros={liberarFiltros}
      onChange={onLiberarFiltroChange}
      onLiberarFactura={onLiberarFactura}
      onClearLiberar={onClearLiberar}
      liberando={liberando}
    />
  </div>
);

export default CierreDiaListForm;
